import React, { useEffect, useState } from "react";
import ContentVisibilityContext from "./ContentVisibilityContext";

// Keep the same subtree after its first opening, including forms and modals.
export default function MountOnFirstOpen({ open, children, trackVisibility = false }) {
  const [visited, setVisited] = useState(open);
  useEffect(() => {
    if (open) setVisited(true);
  }, [open]);
  if (!open && !visited) return null;
  return trackVisibility ? (
    <ContentVisibilityContext.Provider value={Boolean(open)}>
      {children}
    </ContentVisibilityContext.Provider>
  ) : children;
}
